import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {DashboardComponent} from './demo/view/dashboard.component';
import {DashboardAnalyticsComponent} from './demo/view/dashboardanalytics.component';
import {FormLayoutDemoComponent} from './demo/view/formlayoutdemo.component';
import {InvalidStateDemoComponent} from './demo/view/invalidstatedemo.component';
import {PanelsDemoComponent} from './demo/view/panelsdemo.component';
import {OverlaysDemoComponent} from './demo/view/overlaysdemo.component';
import {MediaDemoComponent} from './demo/view/mediademo.component';
import {MenusDemoComponent} from './demo/view/menusdemo.component';
import {MessagesDemoComponent} from './demo/view/messagesdemo.component';
import {MiscDemoComponent} from './demo/view/miscdemo.component';
import {EmptyDemoComponent} from './demo/view/emptydemo.component';
import {ChartsDemoComponent} from './demo/view/chartsdemo.component';
import {FileDemoComponent} from './demo/view/filedemo.component';
import {DocumentationComponent} from './demo/view/documentation.component';
import {AppMainComponent} from './app.main.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import {AppContactusComponent} from './pages/app.contactus.component';
import {AppErrorComponent} from './pages/app.error.component';
import {AppAccessdeniedComponent} from './pages/app.accessdenied.component';
import {AppLoginComponent} from './pages/app.login.component';
import {AppLandingComponent} from './pages/app.landing.component';
import {InputDemoComponent} from './demo/view/inputdemo.component';
import {FloatLabelDemoComponent} from './demo/view/floatlabeldemo.component';
import {ButtonDemoComponent} from './demo/view/buttondemo.component';
import {TableDemoComponent} from './demo/view/tabledemo.component';
import {ListDemoComponent} from './demo/view/listdemo.component';
import {AppTimelineDemoComponent} from './pages/app.timelinedemo.component';
import {TreeDemoComponent} from './demo/view/treedemo.component';
import {DisplayComponent} from './utilities/display.component';
import {ElevationComponent} from './utilities/elevation.component';
import {FlexboxComponent} from './utilities/flexbox.component';
import {GridComponent} from './utilities/grid.component';
import {IconsComponent} from './utilities/icons.component';
import {WidgetsComponent} from './utilities/widgets.component';
import {SpacingComponent} from './utilities/spacing.component';
import {TypographyComponent} from './utilities/typography.component';
import {TextComponent} from './utilities/text.component';
import {AppCrudComponent} from './pages/app.crud.component';
import {AppCalendarComponent} from './pages/app.calendar.component';
import {AppInvoiceComponent} from './pages/app.invoice.component';
import {AppHelpComponent} from './pages/app.help.component';
import {BookingSummaryComponent} from './booking-summary/booking-summary.component';
import {AuthenticationGuard} from './login/authentication.guard';
import {VesselSchedulesComponent} from './vessel-schedules/vessel-schedules.component';
import {ShipmentTrackingComponent} from './shipment-tracking/shipment-tracking.component';
import {InvoicesComponent} from './invoices/invoices.component';
import {UserRolesComponent} from './login/user-roles/user-roles.component';
import {PdfViewerWidgetComponent} from './@shared/widgets/pdf-viewer-widget/pdf-viewer-widget.component';
import {StatementOfAccountsComponent} from './statement-of-accounts/statement-of-accounts.component';
import {ShippingInstructionComponent} from './shipping-instruction/shipping-instruction.component';
// @ts-ignore
import {ConfigPanelComponent} from './config-panel/config-panel.component';
import {NotificationsComponent} from './notifications/notifications.component';
import {TrackingStandaloneVerticalComponent} from './shipment-tracking/tracking-standalone-vertical/tracking-standalone-vertical.component';
import {DocumentsListingComponent} from './documents-listing/documents-listing.component';
import {HomePageComponent} from './home-page/home-page.component';
import {PreviewSiComponent} from './shipping-instruction/preview-si/preview-si.component';
import {CustomerOnboardingComponent} from './user-management/customer-onboarding/customer-onboarding.component';
import {DataSyncLogsComponent} from './data-sync-logs/data-sync-logs.component';
import {ApplicationAnalyticsComponent} from './application-analytics/application-analytics.component';
import {UserMgmtComponent} from './user-mgmt/user-mgmt.component';
import {AddEditUserFormComponent} from './user-mgmt/add-edit-user-form/add-edit-user-form.component';
import {RolesMgmtComponent} from './roles-mgmt/roles-mgmt.component';
import {AddEditRoleFormComponent} from './roles-mgmt/add-edit-role-form/add-edit-role-form.component';
import {ShipmentDetailsAndTrackingComponent} from './booking-summary/shipment-details-and-tracking/shipment-details-and-tracking.component';
import {FrTrainingVideosComponent} from './fr-training-videos/fr-training-videos.component';


const routes: Routes = [
    {path: '', pathMatch: 'full', redirectTo: '/home'},
    {path: 'dashboard', component: DashboardComponent},
    {path: 'home', component: HomePageComponent, data: {title: 'Home - Freight Platform'}},
    {
        path: '',
        component: AppMainComponent,
        canActivate: [AuthenticationGuard],
        children: [
            // FF Routing
            {path: 'booking-summary', component: BookingSummaryComponent, data: {title: 'Booking Summary'}},
            {path: 'schedules', component: VesselSchedulesComponent, data: {title: 'Schedules'}},
            {
                path: 'shipment-tracking',
                component: ShipmentTrackingComponent,
                data: {title: 'Shipment Tracking'}
            },
            {
                path: 'tracking-vertical',
                component: TrackingStandaloneVerticalComponent,
                data: {title: 'Shipment Tracking'}
            },
            {path: 'invoices', component: InvoicesComponent, data: {title: 'Invoices & Documents'}},
            {path: 'shipment-details', component: ShipmentDetailsAndTrackingComponent, data: {title: 'Shipment Details'}},
            {path: 'user-roles', component: UserRolesComponent, data: {title: 'User Roles'}},
            {path: 'documents-listing', component: DocumentsListingComponent, data: {title: 'Documents Listing'}},
            {path: 'pdf-viewer', component: PdfViewerWidgetComponent, data: {title: 'Document Viewer'}},
            {
                path: 'shipping-instructions',
                component: ShippingInstructionComponent,
                data: {title: 'Shipping Instructions'}
            },
            {
                path: 'account-statements',
                component: StatementOfAccountsComponent,
                data: {title: 'Statement of Accounts'}
            },
            {path: 'config-control', component: ConfigPanelComponent, data: {title: 'Configuration'}},
            {path: 'notifications', component: NotificationsComponent, data: {title: 'In App Notifications'}},
            {path: 'user-management', component: UserMgmtComponent, data: {title: 'User Management'}},
            {path: 'manage-user', component: AddEditUserFormComponent, data: {title: 'User Management'}},
            {path: 'roles-management', component: RolesMgmtComponent, data: {title: 'Roles Management'}},
            {path: 'manage-role', component: AddEditRoleFormComponent, data: {title: 'Roles Management'}},
            {path: 'preview-si', component: PreviewSiComponent, data: {title: 'Preview Shipment Instructions'}},
            {path: 'customer-onboard', component: CustomerOnboardingComponent, data: {title: 'Customer Onboard'}},
            {path: 'data-sync-logs', component: DataSyncLogsComponent, data: {title: 'Application Data Analytics'}},
            {path: 'web-analytics', component: ApplicationAnalyticsComponent, data: {title: 'Web Analytics'}},
            {path: 'fr-training-videos', component: FrTrainingVideosComponent, data: {title: 'Training Videos'}},
            // Theme Default
            {path: 'favorites/dashboardanalytics', component: DashboardAnalyticsComponent},
            {path: 'uikit/formlayout', component: FormLayoutDemoComponent},
            {path: 'uikit/floatlabel', component: FloatLabelDemoComponent},
            {path: 'uikit/invalidstate', component: InvalidStateDemoComponent},
            {path: 'uikit/input', component: InputDemoComponent},
            {path: 'uikit/button', component: ButtonDemoComponent},
            {path: 'uikit/table', component: TableDemoComponent},
            {path: 'uikit/list', component: ListDemoComponent},
            {path: 'uikit/tree', component: TreeDemoComponent},
            {path: 'uikit/panel', component: PanelsDemoComponent},
            {path: 'uikit/overlay', component: OverlaysDemoComponent},
            {path: 'uikit/menu', component: MenusDemoComponent},
            {path: 'uikit/media', component: MediaDemoComponent},
            {path: 'uikit/message', component: MessagesDemoComponent},
            {path: 'uikit/misc', component: MiscDemoComponent},
            {path: 'uikit/charts', component: ChartsDemoComponent},
            {path: 'uikit/file', component: FileDemoComponent},
            {path: 'utilities/display', component: DisplayComponent},
            {path: 'utilities/elevation', component: ElevationComponent},
            {path: 'utilities/flexbox', component: FlexboxComponent},
            {path: 'utilities/grid', component: GridComponent},
            {path: 'utilities/icons', component: IconsComponent},
            {path: 'utilities/widgets', component: WidgetsComponent},
            {path: 'utilities/spacing', component: SpacingComponent},
            {path: 'utilities/typography', component: TypographyComponent},
            {path: 'utilities/text', component: TextComponent},
            {path: 'pages/crud', component: AppCrudComponent},
            {path: 'pages/calendar', component: AppCalendarComponent},
            {path: 'pages/timeline', component: AppTimelineDemoComponent},
            {path: 'pages/invoice', component: AppInvoiceComponent},
            {path: 'pages/help', component: AppHelpComponent},
            {path: 'pages/empty', component: EmptyDemoComponent},
            {path: 'documentation', component: DocumentationComponent}
        ]
    },
    {path: 'error', component: AppErrorComponent},
    {path: 'access', component: AppAccessdeniedComponent},
    {path: 'notfound', component: AppNotfoundComponent},
    {path: 'contactus', component: AppContactusComponent},
    {path: 'ultima-login', component: AppLoginComponent},
    {path: 'landing', component: AppLandingComponent},
    // {path: 'login', component: LoginComponent},
    {path: '**', redirectTo: '/notfound', data: {title: 'Page Not Found'}},
];

@NgModule({
    // imports: [
    //     RouterModule.forRoot([
    //         {path: 'login', component: LoginComponent},
    //         {
    //             path: '', component: AppMainComponent,
    //             // canActivate: [AuthenticationGuard],
    //             children: [
    //                 {path: '', component: DashboardComponent},
    //
    //                 // FF Routing
    //                 {path: 'booking-summary', component: BookingSummaryComponent},
    //                 // Theme Default
    //                 {path: 'favorites/dashboardanalytics', component: DashboardAnalyticsComponent},
    //                 {path: 'uikit/formlayout', component: FormLayoutDemoComponent},
    //                 {path: 'uikit/floatlabel', component: FloatLabelDemoComponent},
    //                 {path: 'uikit/invalidstate', component: InvalidStateDemoComponent},
    //                 {path: 'uikit/input', component: InputDemoComponent},
    //                 {path: 'uikit/button', component: ButtonDemoComponent},
    //                 {path: 'uikit/table', component: TableDemoComponent},
    //                 {path: 'uikit/list', component: ListDemoComponent},
    //                 {path: 'uikit/tree', component: TreeDemoComponent},
    //                 {path: 'uikit/panel', component: PanelsDemoComponent},
    //                 {path: 'uikit/overlay', component: OverlaysDemoComponent},
    //                 {path: 'uikit/menu', component: MenusDemoComponent},
    //                 {path: 'uikit/media', component: MediaDemoComponent},
    //                 {path: 'uikit/message', component: MessagesDemoComponent},
    //                 {path: 'uikit/misc', component: MiscDemoComponent},
    //                 {path: 'uikit/charts', component: ChartsDemoComponent},
    //                 {path: 'uikit/file', component: FileDemoComponent},
    //                 {path: 'utilities/display', component: DisplayComponent},
    //                 {path: 'utilities/elevation', component: ElevationComponent},
    //                 {path: 'utilities/flexbox', component: FlexboxComponent},
    //                 {path: 'utilities/grid', component: GridComponent},
    //                 {path: 'utilities/icons', component: IconsComponent},
    //                 {path: 'utilities/widgets', component: WidgetsComponent},
    //                 {path: 'utilities/spacing', component: SpacingComponent},
    //                 {path: 'utilities/typography', component: TypographyComponent},
    //                 {path: 'utilities/text', component: TextComponent},
    //                 {path: 'pages/crud', component: AppCrudComponent},
    //                 {path: 'pages/calendar', component: AppCalendarComponent},
    //                 {path: 'pages/timeline', component: AppTimelineDemoComponent},
    //                 {path: 'pages/invoice', component: AppInvoiceComponent},
    //                 {path: 'pages/help', component: AppHelpComponent},
    //                 {path: 'pages/empty', component: EmptyDemoComponent},
    //                 {path: 'documentation', component: DocumentationComponent}
    //             ]
    //         },
    //         {path: 'error', component: AppErrorComponent},
    //         {path: 'access', component: AppAccessdeniedComponent},
    //         {path: 'notfound', component: AppNotfoundComponent},
    //         {path: 'contactus', component: AppContactusComponent},
    //         {path: 'ultima-login', component: AppLoginComponent},
    //         {path: 'landing', component: AppLandingComponent},
    //         {path: '**', redirectTo: '/notfound'},
    //     ], {scrollPositionRestoration: 'enabled'})
    // ],
    imports: [
        RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
